// Should stay in sync with deltaTrends.mjs

const DELTA_TRENDS = {
  SUSTAINED_STRENGTH: 0,
  SUSTAINED_CHALLENGE: 1,
  EMERGING_STRENGTH: 2,
  EMERGING_CHALLENGE: 3,
  PAST_STRENGTH: 4,
  RESOLVED_CHALLENGE: 5
};

export default DELTA_TRENDS;
